import { ThemeProvider, createTheme } from "@mui/material";
import { IContextData, ThemeActionKind } from "./Entities";
import { ReactNode, useEffect, useReducer } from "react";
import {
	themeReducer,
	InitContextData,
	themes,
	ThemeContext,
} from "./ThemeProvider";

export default function VevyThemeProvider({
	children,
}: {
	children: ReactNode | ReactNode[];
}) {
	const [data, dispatch] = useReducer(themeReducer, InitContextData());
	const context: IContextData = {
		data,
		dispatch,
		setDarkMode,
		isDark,
		getColor,
		setColor,
		getListColor,
	};
	const currTheme = themes.find((t) => t.name == data.color);
	const theme = createTheme({
		palette: {
			mode: data?.mode,
			primary: { main: currTheme?.palette.primary ?? "#3f51b5" },
			secondary: { main: currTheme?.palette.primary ?? "#f50057" },
		},
	});

	useEffect(() => {
		localStorage.setItem("vevyTheme", JSON.stringify(data));
	}, [data]);

	function setDarkMode(isDark: boolean) {
		dispatch({
			action: ThemeActionKind.CHANGE_DARK_MODE,
			payload: isDark ? "dark" : "light",
		});
	}

	function isDark(): boolean {
		return data.mode == "dark";
	}

	function setColor(color: string): void {
		dispatch({
			action: ThemeActionKind.CHANGE_COLOR,
			payload: color,
		});
	}

	function getColor(): string {
		return data.color;
	}

	function getListColor(): string[] {
		return themes.map((t) => t.name);
	}

	return (
		<ThemeContext.Provider value={context}>
			<ThemeProvider theme={theme}>{children}</ThemeProvider>
		</ThemeContext.Provider>
	);
}
